export default __webpack_public_path__ + "static/Blockchain-technology-a674558320eb411412dd3b90aa4fdab4.webp";